import React, { useState } from "react";
import { MdAdd, MdOutlineDelete, MdOutlinedFlag, MdRemoveRedEye } from "react-icons/md";
import { RxEyeOpen, RxPencil1 } from "react-icons/rx";
import { Link, useParams } from "react-router-dom";
import { observer } from "mobx-react";
import Moment from "react-moment";
import { useAuthStore } from "../Auth/store/Auth";
import { useEffect } from "react";
import { ProductCatalogStore, ProductCatalogStoreContext, useProductCatalogStore } from "./Store/ProductCatalogStore";
import { Input, Textarea } from "react-daisyui";
import ReactPaginate from "react-paginate";
const DesignCategory = () => {
    const store = new ProductCatalogStore({
        isloading: true,
        editloading: false
    });
    return (
        <ProductCatalogStoreContext.Provider value={store}>
            <Screen />
        </ProductCatalogStoreContext.Provider>
    )
};
export default DesignCategory;

const Screen = observer(() => {
    const {

        DegienCategoryLoader,
        Coupenpopup,
        coupon,
        designId,
        loadCoupon,
        deletepopup,
        delateLoader,
        DesignCategoryData,
        designIdloder,
        TotalDeginPages,
        design_id,
        ProductIdpopup,
        setcoupenpopup,
        getcouponid,
        nolist,
        CategoryName,
        saved,
        setdesign_id,
        setCategoryName,
        addDesignId,
        designIdstatusChange,
        getPaginationDesginList,
        setPaginationDesginIdPage,
        designIddeletefunction,
        getDesignCategoryList,
        getDesignList,
        setProductIdpopup,
        getid,
        setdelateLoader,
        setdeletepopup,
        deletefunction,
        getstatus,
        updateCategoryName,
        categorystatusChange,
        statusChange,
        getToken
    } = useProductCatalogStore();
    const { adminAuthApproved } = useAuthStore();
    const { id } = useParams();
    const [Key, setkey] = useState("none");
    const [oldname, setoldname] = useState("");
    const [editPopup, seteditPopup] = useState(false);
    const [category_id, setcategory_id] = useState("");
    const ITEMS_PER_PAGE = 10;
    const [currentDesginPage, setDesginPage] = useState(0);
    useEffect(() => {
        if (adminAuthApproved) {
            getToken(localStorage.getItem("Admintoken"));
        }

    }, [adminAuthApproved]);

    const handleClick = () => {
        const element = document.getElementById("tablescroll");
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    }
    useEffect(() => {
        if(saved){
            seteditPopup(false)

        }
    }, [saved])
    useEffect(() => {
        getDesignCategoryList(id)
    }, [])
    const handlePageDesginChange = ({ selected }) => {
        setPaginationDesginIdPage(selected + 1);
        // getFilterProductCatalog();
        // getFilterProductCatalog();
        getPaginationDesginList()
        setDesginPage(selected);
    }

    const handleSubmit = (e, type, categorid) => {
        e.preventDefault();
        addDesignId(type, categorid);
    };

    return (
        <>
            <div className="flex justify-between mt-[51px] ">
                <div className=" mb-4">
                    <p className=" text-2xl font-semibold">Design Categories List</p>
                    {/* <p className=" opacity-80 text-sm">Home / League</p> */}
                </div>
                <div>
                    <Link
                        to={`/addcategorty/${id}`}
                        className="btn btn-sm bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                    >
                        <MdAdd />
                        Add Category
                    </Link>
                </div>
            </div>
            {/* <Filter /> */}

            <div className="card bg-base-100 shadow-md p-6 mt-8">
                <div className="overflow-x-auto w-full">
                    <table className="table table-zebra w-full">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Category Name</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody className="text-sm relative">
                            {DegienCategoryLoader && (
                                <>
                                    <tr>
                                        <td colSpan={11} className="animate-pulse py-6"></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={11} className="animate-pulse py-6"></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={11} className="animate-pulse py-6"></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={11} className="animate-pulse py-6"></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={11} className="animate-pulse py-6"></td>
                                    </tr>
                                </>
                            )}

                            {DesignCategoryData.map((data, index) => (
                                <tr key={index} >
                                    <td>{index + 1}</td>
                                    <td className="capitalize">{data?.category ?? "N/A"}</td>

                                    <th>
                                        <label
                                            title="Coupon Status"
                                            htmlFor="couponstatus"
                                            className={`btn capitalize ${data?.is_active
                                                ? "bg-[#5dff5d] hover:bg-[#5dff5d]"
                                                : "bg-warning hover:bg-warning"
                                                } text-[#000] border-hidden  btn-xs`}
                                            onClick={(e) => {
                                                setcoupenpopup(true);
                                                setcategory_id(data.category)
                                                getstatus(data?.is_active ? 0 : 1);
                                            }}
                                        >
                                            {data?.is_active ? "Active" : "Inactive"}
                                        </label>
                                    </th>
                                    <td className="text-base">
                                        <div className="flex items-center space-x-4">

                                            <label
                                                title="Edit"
                                                htmlFor="my-modal-9"
                                                onClick={() => { seteditPopup(true); setoldname(data?.category); setCategoryName(data?.category) }}
                                                className={`btn capitalize  text-white border-hidden  btn-xs`}

                                            >

                                                <RxPencil1 />

                                            </label>

                                            <label
                                                title="View DesignId's"
                                                htmlFor="my-modal-7"
                                                onClick={() => {
                                                    getDesignList(id, data.category);
                                                    getid(id);
                                                    setcategory_id(data.category)
                                                    setProductIdpopup(true);
                                                }}
                                                className={`btn capitalize  text-white border-hidden  btn-xs`}

                                            >

                                                <MdRemoveRedEye />

                                            </label>

                                        </div>
                                    </td>
                                </tr>
                            ))}

                            {nolist && (
                                <tr>
                                    <td colSpan={9} className="my-10 text-center">
                                        <MdOutlinedFlag className=" text-[#dedede] text-8xl mx-auto" />
                                        <p className=" font-semibold text-lg">No Categories Found</p>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {deletepopup &&
                        <>
                            <input type="checkbox" id="deletecity" className="modal-toggle" />
                            <div className="modal">
                                <div className="modal-box relative">
                                    <label

                                        className="btn btn-sm btn-circle absolute right-2 top-2"
                                        onClick={() => { setdelateLoader(false); setdeletepopup(false) }}
                                    >
                                        ✕
                                    </label>
                                    <h3 className="text-lg font-bold text-center">
                                        Are you sure you want to Delete this Coupon
                                    </h3>
                                    <div className="modal-action justify-center">
                                        {/* <label
                                            htmlFor="deletecity"
                                            className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                            onClick={() => deletefunction()}
                                        >
                                            Yes
                                        </label> */}
                                        {!delateLoader ?
                                            <label

                                                className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                                onClick={() => deletefunction()}
                                            >
                                                Yes
                                            </label> :
                                            <button
                                                // type="submit"
                                                disabled
                                                className="flex items-center bg-color_theme px-3 mx-5 rounded-md"
                                            // onClick={() => {
                                            //   PostMatchscore();
                                            // }}
                                            >
                                                Yes..
                                                <svg
                                                    className="animate-spin mr-1 h-5 w-5 text-white"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <circle
                                                        className="opacity-25"
                                                        cx="12"
                                                        cy="12"
                                                        r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"
                                                    ></circle>
                                                    <path
                                                        className="opacity-75"
                                                        fill="currentColor"
                                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    ></path>
                                                </svg>
                                            </button>}
                                        <label
                                            onClick={() => setdeletepopup(false)}
                                            className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]">
                                            No
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    {Coupenpopup && (
                        <>
                            <input
                                type="checkbox"
                                id="couponstatus"
                                className="modal-toggle"
                            />
                            <div className="modal">
                                <div className="modal-box relative">
                                    <label
                                        className="btn btn-sm btn-circle absolute right-2 top-2"
                                        onClick={() => setcoupenpopup(false)}
                                    >
                                        ✕
                                    </label>
                                    <h3 className="text-lg font-bold text-center">
                                        Are you sure you want to change Status ?
                                    </h3>
                                    <div className="modal-action justify-center">
                                        {!DegienCategoryLoader ? (
                                            <label
                                                className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                                onClick={() => categorystatusChange(category_id, id)}
                                            >
                                                Yes
                                            </label>
                                        ) : (
                                            <button
                                                // type="submit"
                                                disabled
                                                className="flex items-center bg-color_theme px-3 mx-5 rounded-md"
                                            // onClick={() => {
                                            //   PostMatchscore();
                                            // }}
                                            >
                                                Yes..
                                                <svg
                                                    className="animate-spin mr-1 h-5 w-5 text-white"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <circle
                                                        className="opacity-25"
                                                        cx="12"
                                                        cy="12"
                                                        r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"
                                                    ></circle>
                                                    <path
                                                        className="opacity-75"
                                                        fill="currentColor"
                                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    ></path>
                                                </svg>
                                            </button>
                                        )}

                                        <label
                                            onClick={() => setcoupenpopup(false)}
                                            // htmlFor="voidstatus"
                                            className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                                        >
                                            No
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    {ProductIdpopup &&
                        <>
                            <input type="checkbox" id="my-modal-7" className="modal-toggle" />
                            <div className="modal">
                                <div className="modal-box space-y-5 relative">
                                    <label

                                        className="btn btn-sm btn-circle  absolute right-2 top-2"
                                        onClick={() => {
                                            setProductIdpopup(false);
                                            //  setProductIdIndex(null); 
                                        }}
                                    >
                                        x
                                    </label>
                                    <div className="space-y-2">

                                        <div className="flex space-x-5 text-center items-center">
                                            <div className="flex w-full max-h-[330px] overflow-auto   ">
                                                <table id="tablescroll" className="table table-zebra w-full">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>Design ID</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="text-sm relative">
                                                        {designIdloder &&
                                                            <>
                                                                <tr>
                                                                    <td colSpan={7} className="animate-pulse py-6"></td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={7} className="animate-pulse py-6"></td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={7} className="animate-pulse py-6"></td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={7} className="animate-pulse py-6"></td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={7} className="animate-pulse py-6"></td>
                                                                </tr>
                                                            </>
                                                        }
                                                        {
                                                            (designId.length === 0 ? designId : designId)?.map((data, index) => (
                                                                <tr key={index} className="capitalize">
                                                                    <td> {currentDesginPage * ITEMS_PER_PAGE + index + 1}
                                                                    </td>
                                                                    <td
                                                                    >

                                                                        {data?.design_id}


                                                                    </td>







                                                                    <th >




                                                                        <div className="flex items-center space-x-3">
                                                                            <span

                                                                                className={`btn capitalize Active" ${data?.is_active === 1 ? "bg-[#5dff5d] hover:bg-[#5dff5d]" : "bg-warning hover:bg-warning"}  text-[#000] border-hidden  btn-xs`}
                                                                                onClick={(e) => {
                                                                                    // getid(data?.product_id);
                                                                                    designIdstatusChange(data?.record_id, data?.is_active === 1 ? 0 : 1, category_id)
                                                                                    // getdesignIdstatus(data?.is_active === 1 ? 0 : 1);
                                                                                }}
                                                                            >
                                                                                {data?.is_active === 1 ? "Active" : "Inactive"}
                                                                            </span>
                                                                            <label
                                                                                htmlFor="deletecity"
                                                                                className=" text-[#d02c2c] cursor-pointer"
                                                                                title="Delete"
                                                                                onClick={() => { designIddeletefunction(data?.record_id, category_id); }}
                                                                            >
                                                                                <MdOutlineDelete />
                                                                            </label>


                                                                        </div>


                                                                    </th>


                                                                </tr>
                                                            ))
                                                        }


                                                    </tbody>
                                                </table>

                                            </div>


                                        </div>
                                        {designId.length > 0 &&

                                            <ReactPaginate
                                                initialPage={0}
                                                pageCount={Math.ceil(TotalDeginPages)}
                                                pageRangeDisplayed={5}
                                                marginPagesDisplayed={2}
                                                onPageChange={handlePageDesginChange}
                                                onClick={handleClick}
                                                containerClassName={'pagination'}
                                                activeClassName={'active'}

                                            />
                                        }

                                        {/* <ReactPaginate
                                            initialPage={0}
                                            pageCount={Math.ceil(designIdTotalPages)}
                                            pageRangeDisplayed={5}
                                            marginPagesDisplayed={2}
                                            onPageChange={handlePageChange}
                                            onClick={handleClick}
                                            containerClassName={'pagination'}
                                            activeClassName={'active'}

                                        /> */}


                                        {/* {designId.length == 0 &&
                                            <Button
                                                onClick={() => setviewInput(true)}
                                                className="flex justify-center items-center text-center text-[white]">
                                                Add DesignId'S</Button>

                                        } */}
                                        {Key == "none" &&
                                            <div className=" flex justify-center items-center gap-3">

                                                <button
                                                    onClick={() => setkey("single")}
                                                    className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4">
                                                    <MdAdd className="mr-1" />
                                                    Single Design Id
                                                </button>
                                                <button
                                                    onClick={() => setkey("multi")}
                                                    className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4">
                                                    <MdAdd className="mr-1" />
                                                    Muliple Design Id
                                                </button>
                                            </div>
                                        }

                                        {Key == "single" &&
                                            <form onSubmit={(e) => handleSubmit(e, "single", category_id)}>
                                                <div className="space-y-2">
                                                    <Input
                                                        name="Design id"
                                                        value={design_id}
                                                        onChange={(e) => setdesign_id(e.target.value, "single")}
                                                        required
                                                        placeholder="Design id"
                                                        id="Design id"
                                                        type="text"
                                                        autoComplete="off"
                                                        className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                                                    />


                                                </div>
                                                <div className=" flex space-x-1 items-center justify-end mt-3">
                                                    <span className="underline cursor-pointer  " onClick={() => setkey("none")}  > Cancel</span>
                                                    <button

                                                        className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4">
                                                        <MdAdd className="mr-1" />
                                                        add
                                                    </button>


                                                </div>

                                            </form>
                                        }
                                        {Key == "multi" &&

                                            <form onSubmit={(e) => handleSubmit(e, "multi", category_id)}>
                                                <div className="space-y-2">
                                                    <Textarea
                                                        name="Design id"
                                                        value={design_id}
                                                        onChange={(e) => setdesign_id(e.target.value, "multi")}
                                                        required
                                                        placeholder='Please Paste Array of String i.e ["designId1" , "designId2" ,  "designId3" ]'
                                                        id="Design id"
                                                        type="text"
                                                        autoComplete="off"
                                                        className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                                                    />


                                                </div>
                                                <div className=" flex space-x-1 items-center justify-end mt-3">
                                                    <span className="underline cursor-pointer  " onClick={() => setkey("none")}  > Cancel</span>
                                                    <button

                                                        className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4">
                                                        <MdAdd className="mr-1" />
                                                        add
                                                    </button>


                                                </div>

                                            </form>

                                        }

                                    </div>

                                </div>
                            </div>

                        </>
                    }
                    {Coupenpopup && (
                        <>
                            <input
                                type="checkbox"
                                id="couponstatus"
                                className="modal-toggle"
                            />
                            <div className="modal">
                                <div className="modal-box relative">
                                    <label
                                        className="btn btn-sm btn-circle absolute right-2 top-2"
                                        onClick={() => setcoupenpopup(false)}
                                    >
                                        ✕
                                    </label>
                                    <h3 className="text-lg font-bold text-center">
                                        Are you sure you want to change Status ?
                                    </h3>
                                    <div className="modal-action justify-center">
                                        {!DegienCategoryLoader ? (
                                            <label
                                                className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                                onClick={() => categorystatusChange(category_id, id)}
                                            >
                                                Yes
                                            </label>
                                        ) : (
                                            <button
                                                // type="submit"
                                                disabled
                                                className="flex items-center bg-color_theme px-3 mx-5 rounded-md"
                                            // onClick={() => {
                                            //   PostMatchscore();
                                            // }}
                                            >
                                                Yes..
                                                <svg
                                                    className="animate-spin mr-1 h-5 w-5 text-white"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <circle
                                                        className="opacity-25"
                                                        cx="12"
                                                        cy="12"
                                                        r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"
                                                    ></circle>
                                                    <path
                                                        className="opacity-75"
                                                        fill="currentColor"
                                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    ></path>
                                                </svg>
                                            </button>
                                        )}

                                        <label
                                            onClick={() => setcoupenpopup(false)}
                                            // htmlFor="voidstatus"
                                            className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                                        >
                                            No
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    {editPopup &&

                        (<>
                            <input
                                type="checkbox"
                                id="my-modal-9"
                                className="modal-toggle"
                            />
                            <div className="modal">
                                <div className="modal-box relative">
                                    <label
                                        className="btn btn-sm btn-circle absolute right-2 top-2"
                                        onClick={() => seteditPopup(false)}
                                    >
                                        ✕
                                    </label>
                                    <h3 className="text-lg font-bold text-center">
                                        Edit Category Name ?
                                    </h3>
                                    <div className="modal-action flex flex-col justify-center">
                                        <div>
                                            <label
                                                htmlFor="name"
                                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                                            >
                                                Full name<span className="text-[#f00]">&nbsp;*</span>
                                            </label>
                                            <Input
                                                name="name"
                                                required
                                                placeholder="name"
                                                value={CategoryName}
                                                onChange={(e) => { setCategoryName(e.target.value); }}
                                                id="name"
                                                type="text"
                                                autoComplete="off"
                                                className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                                            />


                                        </div>

                                        <div className="flex gap-1 mt-3 justify-end">
                                            {!DegienCategoryLoader ? (
                                                <label
                                                    className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                                    onClick={() => updateCategoryName(oldname, id)}
                                                >
                                                    Edit
                                                </label>
                                            ) : (
                                                <button
                                                    // type="submit"
                                                    disabled
                                                    className="flex items-center bg-color_theme px-3 mx-5 rounded-md"
                                                // onClick={() => {
                                                //   PostMatchscore();
                                                // }}
                                                >
                                                    Edit..
                                                    <svg
                                                        className="animate-spin mr-1 h-5 w-5 text-white"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <circle
                                                            className="opacity-25"
                                                            cx="12"
                                                            cy="12"
                                                            r="10"
                                                            stroke="currentColor"
                                                            strokeWidth="4"
                                                        ></circle>
                                                        <path
                                                            className="opacity-75"
                                                            fill="currentColor"
                                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                        ></path>
                                                    </svg>
                                                </button>
                                            )}

                                            <label
                                                onClick={() => seteditPopup(false)}
                                                // htmlFor="voidstatus"
                                                className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                                            >
                                                No
                                            </label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </>
                        )

                    }

                </div>
            </div>
        </>
    );
});
//
